const owners = Object.freeze({
  'Comitê com afastamento de membro': 'Comitê com afastamento de membro',
  'Comitê de Compliance': 'Comitê de Compliance',
  'Compliance officers': 'Compliance officers',
  'Diretoria/CAD/Presidência': 'Diretoria/CAD/Presidência',
  'Comitê de Riscos e Auditoria': 'Comitê de Riscos e Auditoria',
  Outro: 'Outro'
})

export default owners
